import { useState, useEffect } from "react";
import { HStack, Tooltip, useDisclosure, Button, useColorModeValue } from "@chakra-ui/react";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import { AiOutlineDelete, AiOutlineMail } from "react-icons/ai";
import { useRouter } from "next/router";
import { getAccount } from "utils/sessionHelper";
import { addRemovePeopleToList } from "controllers/list";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { useMiscellaneousContext } from "context/miscellaneousContext";

export function Actions({ value, row }) {
  const [finishedDeleting, setFinishedDeleting] = useState<boolean>(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: session } = useSession() ?? {}
  const router = useRouter();
  const miscellaneousContext: any = useMiscellaneousContext();

  // console.log({ value });
  // console.log({ row });
  const { contact, listId, refresher } = value ?? {};

  const handleDelete = async () => {
    try {
      if (
        contact?.id === miscellaneousContext.sidebarPerson?.id
      ) {
        miscellaneousContext.setSidebarPerson(null);
      }
      await addRemovePeopleToList(
        getAccount(session)?.id,
        listId,
        [contact],
        "remove"
      );
      setFinishedDeleting(true);
      toast.success(`Successfully removed ${contact?.firstName} from the list`);
    } catch (err) {
      console.log("Error in removing person from the list: ", err);
      toast.error("Error in removing person from the list: " + err.message);
    }
  };

  useEffect(() => {
    if (finishedDeleting) {
      refresher({});
    }
  }, [finishedDeleting]);

  const handleEngage = (e) => {
    e.stopPropagation();
    miscellaneousContext.setCrmEngage(contact?.twUserName);
    router.push("/engage?tab=custom");
  };

  return (
    <>
      <HStack justifyContent="center" alignItems="center" spacing="0">
        <Tooltip label="DM">
          <span
            onClick={(e) => {
              e.stopPropagation();
              miscellaneousContext.setCrmDm([contact]);
              router.push({ pathname: "/dm", query: { from: "crm" } }, "/dm");
            }}
          >
            <Button variant="action" size="sm">
              <AiOutlineMail color={useColorModeValue("#54A9FF", "#05488B")} cursor="pointer" size={16} />
            </Button>
          </span>
        </Tooltip>
        <Tooltip label="Delete">
          <span>
          <Button variant="actionDestructive" size="sm">
            <AiOutlineDelete
              color="red"
              cursor="pointer"
              size={16}
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
              }}
              />
            </Button>
          </span>
        </Tooltip>
      </HStack>
      <ConfirmPopup
        isOpen={isOpen}
        onClose={onClose}
        title={`Deleting`}
        body={
          <>
            Are you sure you want remove <b>{contact?.name ?? contact?.profileFullName ?? contact?.firstName + ' ' + contact?.lastName}</b> from the list?
          </>
        }
        callback={handleDelete}
      />
    </>
  );
}
